/**
 * This bootstrap file is used for both frontend and backend
 */
/* eslint-disable */
import $ from "jquery";
import _ from "lodash";
import axios from "axios";
import Swal from "sweetalert2";
import jszip from "jszip";
import pdfmake from "pdfmake";
import Vue from "vue";
import VueMask from "v-mask";
import "bootstrap-sass";
import "bootstrap-touchspin";
import "datatables.net-bs";
import "datatables.net-buttons-bs";
import "datatables.net-responsive-bs";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "highcharts/highstock";
import bootstrapToggle from "bootstrap-toggle";
import JSONFormatter from "json-formatter-js";
import Editor from "@tinymce/tinymce-vue";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = $; // jQuery
window.swal = Swal; // SweetAlert2
Vue.prototype.$swal = Swal;
window._ = _; // Lodash
window.jszip = jszip;
window.pdfmake = pdfmake;
window.Vue = Vue;
window.JSONFormatter = JSONFormatter;
window.Editor = Editor;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

Vue.prototype.$http = axios;
Vue.use(VueMask);

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
    }
});
